<template>
    <f7-app :params="f7params">
        <router-view></router-view>
        <cm-menu></cm-menu>
    </f7-app>
</template>

<script>

import CMMenu  from './components/Menu'
import routers from './router'

export default {
    name: 'app',
    components: {
        'cm-menu': CMMenu,
    },
    data() {
        return {
            f7params: {
                id: 'com.cma.cmrice',
                name: this.$ml.get('title'),
                panel: {
                    swipe: '',
                },
            }
        }
    },
    methods: {
        authentication() {
            if (this.$route.name === 'Login') {
                if (localStorage.userLogin)
                    return this.$router.push({name: 'Dashboard'})
            } else {
                if (! localStorage.userLogin)
                    return this.$router.push({name: 'Login'})

                if (localStorage.permission) {
                    let route = routers.find(o => o.name === this.$route.name)
                    let permissions = JSON.parse(localStorage.permission)
                    if (permissions[route.permission] === false)
                        return this.$router.push({name: 'Dashboard'})
                }
            }
        },
    },
    created() {
        this.authentication()

        // if (this.$route.name !== 'Login')
        //     this.f7params.panel.swipe = 'left'
    },
    watch: {
        $route () {
            this.authentication()

            // if (to.name === 'Login') {
            //     this.$f7 && this.$f7.panel.disableSwipe()
            // } else {
            //     this.$f7 && this.$f7.panel.enableSwipe()
            // }
        }
    }
}
</script>